import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close'; 
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CustomerAddress from "./CustomerAddress";

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [

 
  { id: 'cu_name', numeric: false, label: 'Name' },
  { id: 'cu_emailid', numeric: false, label: 'Email Id' },
  { id: 'cu_phoneno', numeric: false, label: 'Phone No.' },  

    
  { id: '', numeric: false,  label: '' },

]
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});





export default class  Admincustomer extends Component {
	
	
	constructor(props) {
    super();
	
	 this.state = {
logredirect:false,pagename:'',CustomerData:[] ,id:'',editredirect: false,page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],csid:'',csname:'',
	 
	  search:'',order:'desc' ,orderBy:'',name:'',searchnamearray:[],isactive:'',searchactive:'',
		       
      }
	  
	  
	   this.updateDonenewParent = this.updateDonenewParent;
	 }
	

    updateDonenewParent = (text) => {this.componentDidMount();  }
   
  


myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
   

  this.setState({[nam]: val});

}








 handleClickSearch=()=>{


this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,CustomerData:[],Data:[],
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); });
	
 
	
} 

componentDidMount() {
	
		document.title = "Atha yoga Living - Customer Management";  
	
			  
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Default'
          })
		  }
 

  this.apicall(this.state.page,this.state.rowsPerPage); 

  
	}
	
	
	
	
	
	apicall(page,rowsPerPage){
			
  
  axios.get(Serverurl+'ajaxcustomer.php?action=getall&cu_name='+this.state.name+'&cu_isactive='+this.state.isactive+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  
		
    if(resp.data.length>0){

			this.setState({  
			  CustomerData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			});	 
     }
	 else{
		   this.setState({Branchdata:[],totaldata:0});
	 }
   
    });

}


handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 
 deletecustomer(cuid){  
  
		let r = window.confirm("Do you really want to Delete?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','delete')					 
					 formData.append('cu_id',cuid)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					  axios.post(Serverurl+"ajaxcustomer.php", formData, {
						}).then(res => {
					
					this.apicall(this.state.page,this.state.rowsPerPage);
   
 

				  
					
					
							});
		 }
 }
	  

 
  
blockcustomer(cid){
	 
	 let r = window.confirm("Do you really want to Block?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','Inactive')
					 formData.append('cu_id',cid)
					 formData.append('cu_isactive',2)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					 
					  axios.post(Serverurl+"ajaxcustomer.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 
 

unblockcustomer(cid){
	 
	 let r = window.confirm("Do you really want to Unblock?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','Inactive')
					 formData.append('cu_id',cid)
					 formData.append('cu_isactive',0)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					 
					  axios.post(Serverurl+"ajaxcustomer.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 



  AddressAddbox(val,name){
        this.setState({csid:val,csname:name });  
  
         setTimeout(() => this.refs.Addaddressbox.handleClickOpen(),500);

      }

 
render() {

	if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
  
  <React.Fragment>
   

<div className="boxheading">
				
<h2>Customer Management</h2>

</div>
<div className="addandbacbtn"><NavLink  to="/Addcustomer" >New</NavLink></div>
<div className="clear"></div>
   <div className="searchmaster"> 




<ul>
	
<li>
 
<p>Name/Email/Phone No.</p>
		<p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.name}
            id="name"
                inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
            name="name" onChange={this.myChangeHandler}
         
           
          /></p>
		
		</li>
		<li>  
		  
		 <p>Type</p>
		<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"      inputProps={{tabIndex: "2"}} className="txtbox"
          onChange={this.myChangeHandler}
          id="isactive"
		   value={this.state.isactive}
		  name="isactive"
		
        >
	
	<option value="">Select Type</option>
          <option value={0}>Active</option>
          <option value={1}>Inactive</option>	
        </Select>

		</FormControl>
		</p>
 
 </li>
		
<li>
 
<p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p>
 </li>
 
 </ul>
</div>



 
 

 
 
 
 
<Addaddressbox ref="Addaddressbox" csname={this.state.csname} id={this.state.csid}  updateDonenew={this.updateDonenewParent}/>
 
 
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead
             
              
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.CustomerData.length}
            />
			
			
			
                      <TableBody>

                     {stableSort(this.state.CustomerData, getSorting(this.state.order, this.state.orderBy)).map((item,index) =>{
 if(this.state.totaldata>0)					
	 {   return ( <React.Fragment>
 <TableRow key={index} >

	
	

  <TableCell>{item.cu_name}</TableCell>
<TableCell>{item.cu_emailid}</TableCell>
<TableCell>{item.cu_phoneno}</TableCell>
	
	
	
	
	
<TableCell align="left">
<a href={'/Addcustomer?cuid='+item.cu_id}>
<Button variant="contained" className="frmSecondarybtn" endIcon={<EditIcon />}>
Edit
</Button></a>&nbsp;&nbsp;
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.deletecustomer(item.cu_id)}} endIcon={<DeleteIcon />}>
Delete
</Button>&nbsp;&nbsp;

<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.AddressAddbox(item.cu_id,item.cu_name)}} endIcon={<HomeIcon />}>
Address
</Button>&nbsp;&nbsp;

 {(item.cu_isactive ==="0" ) &&(
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.blockcustomer(item.cu_id)}} endIcon={<PersonOffIcon />}>
In Active
</Button>

 )}
	
	
	 {item.cu_isactive !=="0" &&(
<React.Fragment>
	<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.unblockcustomer(item.cu_id)}} endIcon={<PersonIcon />}>
 Active
</Button>

	
	
	

	</React.Fragment>  
  )}	
	
	
	
 </TableCell>

 </TableRow>


				</React.Fragment>	
				);
	 }
						 else{
					 return ( <React.Fragment>
				<TableRow  >
<TableCell colspan="5">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				</React.Fragment>	
				);	
				}
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />    
  </Paper>
   
 

   
 </React.Fragment>

		  );
  }	
   
   
  
	
}






export  class  Addaddressbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  previocn:'',adcsid:'',AdressData:[],adid:'',
		   open:false,name:'',ad_buildingdetails:'',ad_address:'',ad_latitude:'',ad_longitude:'',ad_cs_id:'',ad_id :'',
      errormessage:'',erropen:false,btndisabled:'',bnid:'',
submitbtn:"Save"
	  }
      
  }
  
  
  
 
handleClickOpen = (e) => {

  this.setState({adid:'',open:!this.state.open,ad_id:'',ad_buildingdetails:'',ad_address:'',ad_latitude:'',  ad_longitude:'',ad_cs_id:this.props.id,ad_id:'',
     errormessage:'',erropen:false,AdressData:[],
	  },()=>{this.AddressgetaBind();});
		


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});


}

 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }







handleClose = (e) => {
	
 let ad_buildingdetails = this.state.ad_buildingdetails;
 
 let ad_address = this.state.ad_address;
 let ad_cs_id = this.state.ad_cs_id;
 let ad_latitude = this.state.ad_latitude;
 
 let ad_longitude = this.state.ad_longitude;
if(ad_latitude==="")
{
	
	this.setState({errormessage:"Please Select  Location",erropen:true});
		
		 return false;
	
	
}

if(ad_buildingdetails==="")
{
	
	this.setState({errormessage:"Please Enter Building No./Name",erropen:true});
		
		 return false;
	
	
}

if(ad_address==="")
{
	
	this.setState({errormessage:"Please Enter Address",erropen:true});
		
		 return false;
	
	
}


 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  
  
   if(this.state.ad_id==0)
	  {
		  formData.append('ad_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('ad_id',this.state.ad_id)
		
          }
	  
	  
        formData.append('action','insertupdate') 
		
		formData.append('ad_buildingdetails',ad_buildingdetails)
		formData.append('ad_cs_id',this.props.id)
		formData.append('ad_address',ad_address)
		formData.append('ad_latitude',ad_latitude)
		formData.append('ad_longitude',ad_longitude)

		
	
		
		formData.append('userid',localStorage.getItem("AYLuserid"))
		  
		axios.post(Serverurl+"ajaxaddress.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({btndisabled:false,
	 submitbtn:"Save",errormessage:"Address Already Exist.",erropen:true,
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
		
	this.setState({btndisabled:false,
	 submitbtn:"Save", });
		this.AddressgetaBind();
	}
	
	
           
    
        });
  
	
};




 
 




  
EditAddressdetails(Prodid) {
	   axios.get(Serverurl+'ajaxaddress.php?action=getall&ad_id='+Prodid)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      ad_id:resp.data[0].ad_id,
	  ad_buildingdetails: resp.data[0].ad_buildingdetails,
      ad_address: resp.data[0].ad_address,
	   ad_latitude: resp.data[0].ad_latitude,
	    ad_longitude: resp.data[0].ad_longitude,
	 
   ad_cs_id:resp.data[0].ad_cs_id,
    });
	//this.refs.CustomerAddress.GoogleApiWrapper.setlatlng();
  }
  
});
	 
}

 AddressDelete(adid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('ad_id',adid)
	 	   
formData.append('userid',localStorage.getItem("AYLuserid"))
	
	
	 axios.post(Serverurl+"ajaxaddress.php", formData, {
        }).then(res => {
    
            
 
    this.AddressgetaBind();
  
    
            });
 }
      }

	 
 
    

  
 

 
AddressgetaBind(){
	
 axios.get(Serverurl+'ajaxaddress.php?action=getall&ad_cs_id='+this.state.ad_cs_id)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  AdressData:resp.data,  
			 
			 

		    });
		
			
	 
     }
	 
    });
}

 handlelatlong = (childData) => {
         let self=this;
  var strvalues=childData.split('~');

 this.setState({ad_latitude:strvalues[0],ad_longitude:strvalues[1],ad_address:strvalues[2]});
 }
render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{this.props.csname} Address</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
			<CustomerAddress ref="CustomerAddress" lat={this.state.ad_latitude} lng={this.state.ad_longitude} parentCallback={this.handlelatlong}/>			  
	<div className="addressbox">	
    <p>Building No./Name</p>
		<p><TextField name="ad_buildingdetails" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ad_buildingdetails}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
		
		   
	<p>Address</p>	
 <p><TextField name="ad_address" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.ad_address} 
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "9",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>

		
		</div>   
		 
		
		
		
		
       <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="variamt" className="frmthirdbtn" onClick={this.handleClickOpen}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
	
</div>
	
	



<div className="customeraddress">

{this.state.AdressData.length>0 &&(
	 <ul>
	{this.state.AdressData.map((item,index) => { return ( 
	 
	 <li>
	<p> {item.ad_buildingdetails}</p>
	<p> {item.ad_address}</p>
   
<Button variant="contained" className="frmSecondarybtn"  onClick={()=>{this.EditAddressdetails(item.ad_id)}} endIcon={<EditIcon />}>
Edit
</Button> <Button variant="contained"   className="frmthirdbtn"   onClick={()=>{this.AddressDelete(item.ad_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button> 

	</li>	
	

	 

	 );})}
	</ul>
	 )}


</div>
 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
}